import React from "react";
import * as ReactDOM from "react-dom";

const LoadingPanel = (
  <div className="k-loading-mask" style={{ zIndex: 99999 }}>
    <span className="k-loading-text">Loading</span>
    <div className="k-loading-image"></div>
    <div className="k-loading-color"></div>
  </div>
);

export default LoadingPanel;

export const LoadingPanelComponent = ({ query = "" }) => {
  const gridContent = document && document.querySelector(query);
  return gridContent
    ? ReactDOM.createPortal(LoadingPanel, gridContent)
    : LoadingPanel;
};
